<template>
    <div :class="sizeClass" >
        <div class="popup-header header-blue">
            <h2>{{title}}</h2>
        </div>
        <slot />
        <div class="popup-footer" style="width: 100%">
            <ul class="popup-footer-layout">
                <li class="footer-left">
                    <a v-if="showCancelBtn" @click="onCancelClick" class="button css-button-grey add-form-popup-cancel">Cancel</a>
                    <b-button v-if="showClaimBtns" @click="LeftTabClick" :disabled="isLeftTabDisabled" class="button css-button-green" style="margin-left: 5px;">&lt;</b-button>
                    <b-button v-if="showClaimBtns" @click="RightTabClick" :disabled="isRightTabDisabled" class="button css-button-green" style="margin-left: 5px;">></b-button>
                </li>
                <li class="footer-right">
                    <a v-if="showSaveBtn" @click="onSaveClick" :disabled="isFooterbtnsDisabled" style="margin-left: 5px;" class="button css-button-blue">{{saveBtnTxt}}</a>
                    <a v-if="showAddNewBtn" @click="onAddNewClick" class="button css-button-green">Add New</a>
                    <b-button v-if="showClaimBtns" @click="onPrintAllClick" :disabled="isPrintDisabled" class="button css-button-blue" style="margin-right: 5px; float: right;">Print All</b-button>
                    <b-button v-if="showClaimBtns" @click="onPrintClick" :disabled="isPrintDisabled" class="button css-button-blue" style="margin-right: 5px; float: right;">Print</b-button>

                    <b-button v-if="showClaimBtns" @click="onDeleteClaimClick" :disabled="isDeleteDisabled" class="button css-button-red" style="margin-right: 5px; float: right;">Delete Claim</b-button>
                    <b-button v-if="showClaimBtns" @click="onAddClaimClick" :disabled="isFooterbtnsDisabled" class="button css-button-green" style="margin-right: 5px; float: right;">Add Claim</b-button>
                    
                </li>
            </ul>
        </div>
    </div>
</template>

<script>

export default {
        name: "popup",
        props: {
            title: String,
            showClaimBtns: { type: Boolean, default: false },
            showAddNewBtn: { type: Boolean, default: false },
            showSaveBtn: { type: Boolean, default: true },
            showCancelBtn: { type: Boolean, default: true },
            saveBtnTxt: { type: String, default: "Save" },
            size: { type: String, default: "md" },
            isLeftTabDisabled: { type: Boolean, default: false },
            isRightTabDisabled: { type: Boolean, default: false },
            isDeleteDisabled: { type: Boolean, default: false },
            isPrintDisabled: { type: Boolean, default: false },
            isFooterbtnsDisabled: { type: Boolean, default: false },
        },
        data: function () {
            return {
            };
        },
        mounted: function () {
            //mounted is an event in the lifecyle of a vue component
         },
        computed: {
            sizeClass: function(){
                if (this.size == 'sm')
                    return 'vue-popup-sm this-popup';
                else
                    return 'vue-popup this-popup';
            }
        },
        watch: {

        },
        methods: {
            init: function () {
            },
            close: function () {
                this.$emit('close');
            },
            onCancelClick: function () {
                this.$emit('on-cancel-click');
                // this.$emit('close');
            },
            onOkClick: function () {
                this.$emit('on-ok-click');
            },
            onSaveClick: function () {
                this.$emit('on-save-click');
            },
            onAddNewClick: function () {
                this.$emit('on-add-new-click');
            },
             onAddClaimClick: function () {
                this.$emit('on-add-claim-click');
            },
            onDeleteClaimClick: function () {
                this.$emit('on-delete-claim-click');
            },
             LeftTabClick: function () {
                this.$emit('Left-tab-click');
            },
            RightTabClick: function () {
                this.$emit('Right-tab-click');
            },
            onPrintAllClick: function () {
                this.$emit('on-print-all-click');
            },
             onPrintClick: function () {
                this.$emit('on-print-click');
            },
            
        }
    }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
/* 2.5	Popups
-------------------------------------------*/
.popup span.label, .this-popup .label{float: left; line-height: 2.2em; padding: 0 0 0 5px; font-family:'_.medium', sans-serif; font-size: 1em; color: #fff}
.popup h2, .this-popup h2{line-height: 3.36em; text-transform: uppercase; font-weight: 700; font-size: 11px; color: #fff}
.popup p, .this-popup p{font-size: 11px; color: #fff}
.this-popup font{font-size: 12px;}
.this-popup.form-response-popup p{color: #111}
.this-popup{font-size: 12px; 
overflow:hidden; 
background:#333; 
border-radius:4px; 
box-shadow: 0 15px 30px 5px rgba(50,50,50,0.6); 
-webkit-animation: fadeInOpacity 0.5s; 
animation: fadeInOpacity 0.5s;
position: fixed;
z-index: 10002;
top: 50%;
left: 50%;
transform: translate(-50%, -50%);
width: 50%;
}
.remove-popup {background: #3f3f3f}
.remove-popup > .this-popup {box-shadow: none; border-radius: 0; background:none;}/*CS Had to add this hack because we insist on reusing popups where we shouldn't be*/
.this-popup h2{line-height: 2.8em; text-transform: uppercase; font-weight: 700; font-size: 11px; color: #fff; padding-left:5px}
.this-popup .popup-header{text-align:left; display:table; position: relative; overflow: hidden; border-radius:3px 3px 0 0; width: 100%; height: 30px; box-shadow:0 3px 3px 0 rgba(0, 0, 0, 0.3)}
.this-popup .popup-header h2 {margin-left: 10px;}
.this-popup .header-blue{background:#36c}
.this-popup .header-red{background:#ff4136}
.this-popup .popup-footer{z-index:0; padding: 11px 0; border-top:1px solid #666; border-radius: 0 0 3px 3px; background:#555 !important; position:absolute; bottom:0; -webkit-animation: fadeInOpacity 0.5s; animation: fadeInOpacity 0.5s}
.this-popup .popup-footer-layout{width:100%; display:inline-block}
.this-popup .footer-left{padding-left:2%; width:31%; float:left}
.this-popup .footer-right{padding-right:2%; width:69%; float:right}
.footer-one-third{display:inline-block; width:32.33%; padding:0 0.5%}
.this-popup .footer-three-left{padding-left:1%; width:20%; float:left}
.this-popup .footer-three-middle{padding:0 1%; width:56%; float:left}
.this-popup .footer-three-right{padding-right:1%; width:20%; float:right}
.this-popup .footer-right a{float:right}
.this-popup .footer-right input{float:right}
.this-popup .footer-three-left .css-button-blue{float:left}
.this-popup .footer-three-middle .css-button-blue{float:none}
.this-popup > .this-popup-body{display:block; overflow:auto; width:100%} /*CMS - Set inline height style to ensure scroll*/
.this-popup > .this-popup-footer{display:table; width:100%; background:#555; padding:5px 0}
.this-popup > .flex-popup-content{flex-grow:1; display: flex; flex-direction: column; justify-content:flex-start}
.this-popup > .flex-footer {display: flex; justify-content:space-between; padding: 5px 0; width: 100%; border-top:1px solid #666; border-radius: 0 0 3px 3px; background:#555}
.this-popup .message-body {color:inherit}

/* x-sm */
@media (min-width: 378px) {
    .vue-popup {
        min-width: 100%;
    }
}
/* sm */
@media (min-width: 768px) {
    .vue-popup {
        min-width: 100%;
    }
}
/* md */
@media (min-width: 992px) {
    .vue-popup {
        min-width: 400px;
    }
}
/* lg */
@media (min-width: 1200px) {
    .vue-popup {
        min-width: 450px;
    }
}

/* x-sm */
@media (min-width: 378px) {
    .vue-popup-sm {
        min-width: 75%;
    }
}
/* sm */
@media (min-width: 768px) {
    .vue-popup-sm {
        min-width: 50%;
    }
}
/* md */
@media (min-width: 992px) {
    .vue-popup-sm {
        min-width: 300px;
        max-width: 400px;
    }
}
/* lg */
@media (min-width: 1200px) {
    .vue-popup-sm {
        min-width: 330px;
        max-width: 430px;
    }
}
</style>
